import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/currency-gbp';

const routes: RouteRecordRaw[] = [
	{
		// Every path under /fees opens this page, so a link deep into the Fees admin works: the remote
		// reads the rest of the path itself.
		path: '/fees/:pathMatch(.*)*',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			// Checked synchronously in the router's global guard, so a direct navigation cannot reach the
			// page before the layout's post-mount redirect fires.
			isAllowed: ({ canAccessFees }) => canAccessFees || ROOT_PAGES.MODULES,
			documentTitle: 'Fees',
			title: 'Fees',
		},
	},
];

/**
 * Fees is not built in this repository: it is motorway/mw-fees-admin, loaded at runtime as a Module
 * Federation remote (lib/remote.ts). Gated on the Developer and Admin roles rather than a
 * permission of its own; see `canAccessFees` in src/core/services/user/store.ts.
 */
export const FEES_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'Fees',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessFees }) => canAccessFees,
	routes,
};
